import * as React from 'react';
import { estimationTargetSelectorOptions } from '../../../constants/estimationTargetSelectorOptions';
import { useActions } from './useActions';
import { useSelector } from 'react-redux';
import { selectFilters } from '../../../selectors';
import { trackEstimationTargetSelect } from '../../../analytics';
/**
 * Возвращает набор пропсов для первичного фильтра "Тип оцениваемой недвижимости"
 * */

export var useEstimationTargetProps = function useEstimationTargetProps() {
  var _useActions = useActions(),
      setEstimationTarget = _useActions.setEstimationTarget,
      resetFilters = _useActions.resetFilters;

  var _useSelector = useSelector(selectFilters),
      estimationTarget = _useSelector.estimationTarget;

  var onValueChange = React.useCallback(function (estimationTarget) {
    /** При выборе нового типа оцениваемой недвижимости, сбрасываем все предыдущие фильтры */
    resetFilters();
    setEstimationTarget({
      estimationTarget: estimationTarget
    });
    trackEstimationTargetSelect(estimationTarget);
  }, [setEstimationTarget, resetFilters]);
  return {
    values: estimationTargetSelectorOptions,
    value: estimationTarget,
    placeholder: 'Тип недвижимости',
    onValueChange: onValueChange
  };
};